import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import pinia from "./stores"; // Vue UI 创建的 Pinia 路径是 stores 而非 store
// 引入全局响应式样式（后续创建）
import "./assets/css/style.css";
import "./assets/css/public.scss";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
createApp(App).use(router).use(pinia).use(ElementPlus).mount("#app");
